var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9681_441200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.665 22.167a2.34 2.34 0 0 1 2.333-2.334 2.34 2.34 0 0 1 2.333 2.334 2.34 2.34 0 0 1-2.333 2.333 2.34 2.34 0 0 1-2.333-2.333m15.96-11.037a1.15 1.15 0 0 0 .058-1.645 18.76 18.76 0 0 0-13.685-5.973A18.75 18.75 0 0 0 .313 9.473a1.16 1.16 0 0 0 .058 1.645 1.16 1.16 0 0 0 1.645-.058 16.37 16.37 0 0 1 11.982-5.227A16.4 16.4 0 0 1 25.98 11.06c.233.245.536.373.851.373.28 0 .572-.105.794-.315zm-5.845 5.612a1.15 1.15 0 0 0 .058-1.645 10.7 10.7 0 0 0-7.84-3.43 10.7 10.7 0 0 0-7.84 3.43 1.16 1.16 0 0 0 .058 1.645 1.16 1.16 0 0 0 1.645-.059 8.38 8.38 0 0 1 6.137-2.671c2.322 0 4.55.98 6.137 2.671.233.245.536.374.851.374.28 0 .572-.105.794-.315",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9681_441200"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifi-icon.904e497f64b9099de6e949db54366d7f.svg";
export { ForwardRef as ReactComponent };